const apiUrl = process.env.VITE_API_URL
const baseDomain = process.env.VITE_BASE_DOMAIN
const isLocalHost = window.location.hostname === 'localhost'
const devMode = process.env.VITE_ENV_MODE === 'development'
const isProduction = process.env.VITE_ENV_MODE === 'production'
const auth0Domain = process.env.VITE_AUTH0_DOMAIN
const auth0ClientId = process.env.VITE_AUTH0_CLIENT_ID
const auth0LogoutRedirectUri = process.env.VITE_AUTH0_LOGOUT_REDIRECT_URI
const auth0Audience = process.env.VITE_AUTH0_AUDIENCE
const firebaseApiKey = process.env.VITE_FIREBASE_API_KEY
const firebaseProjectId = process.env.VITE_FIREBASE_PROJECT_ID
const firebaseAppId = process.env.VITE_FIREBASE_APP_ID
const posthogApiKey = process.env.VITE_POSTHOG_API_KEY
const posthogApiHost = process.env.VITE_POSTHOG_API_HOST
const CDN_ENV_SUFFIX = { production: '', qa: '-qa' }
const cdnBaseUrl = `https://cdn${CDN_ENV_SUFFIX[process.env.VITE_ENV_MODE] ?? '-dev'}.cookiearmor.com`

const FIREBASE_CONFIG = {
  apiKey: firebaseApiKey,
  projectId: firebaseProjectId,
  appId: firebaseAppId,
}

export {
  apiUrl,
  baseDomain,
  isLocalHost,
  devMode,
  isProduction,
  auth0Domain,
  auth0ClientId,
  auth0LogoutRedirectUri,
  auth0Audience,
  FIREBASE_CONFIG,
  posthogApiKey,
  posthogApiHost,
  cdnBaseUrl,
}
